module.exports = __webpack_public_path__ + "img/rating.7b089200.webp";